/**
 * テナントが扱える排出事業者の引渡担当者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/emissions`

const search_emission_deliverer = {
  namespaced: true,
  actions: {
    index ({ commit }, { id, emission_location_id }) {
      const api_path = `${API_PATH}/${id}/deliverers`
      const params = {
        emission_location_id: emission_location_id
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
export default search_emission_deliverer
